import type { Payload } from '@/api/interfaces/payload';
import type { UserAccount } from '@/api/interfaces/user/user-account';
import webApiClient from '@/helpers/client/webapi-client';

export function checkAccountUserRelation(accountUuid: Uuid) {
  return webApiClient.post<Payload<UserAccount>>(`/accounts/${accountUuid}/check-user-relation`);
}
